<template>
    <app-layout title="Order History">
        <page-header>
            <template #title>Order History - {{ customer.name }}</template>

            <template #actions>
                <jet-tertiary-button class="leading-none" :href="route('customers.index')">
                    Close
                </jet-tertiary-button>
            </template>
        </page-header>

        <customer-navigation :customer="customer" />

        <div class="px-8">
            <div class="rounded-t overflow-hidden border border-b-0">
                <table class="table table-with-links w-full">
                    <thead>
                        <tr>
                            <th class="text-left">Order #</th>
                            <th class="text-left">Order Date</th>
                            <th class="text-left">Ship Date</th>
                            <th class="text-left">Shipping Method</th>
                            <th class="text-left">Status</th>
                            <th class="text-right">Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="order in orders.data" :key="order.id">
                            <td class="text-left">
                                <Link class="block px-2 py-1" :href="orderUrl(order)">
                                    {{ order.id }}
                                </Link>
                            </td>
                            <td class="text-left">
                                <Link class="block px-2 py-1" :href="orderUrl(order)">
                                    {{ formatDate(order.order_date) }}
                                </Link>
                            </td>
                            <td class="text-left">
                                <Link class="block px-2 py-1" :href="orderUrl(order)">
                                    {{ formatDate(order.ship_date) }}
                                </Link>
                            </td>
                            <td class="text-left">
                                <Link class="block px-2 py-1 capitalize" :href="orderUrl(order)">
                                    {{ order.shipping_method }}
                                </Link>
                            </td>
                            <td class="text-left">
                                <Link class="block px-2 py-1" :href="orderUrl(order)">
                                    {{ order.statusDef }}
                                </Link>
                            </td>
                            <td class="text-right">
                                <Link class="block px-2 py-1" :href="orderUrl(order)">
                                    {{ toCurrency(total(order)) }}
                                </Link>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <pagination class="inline-flex" :links="orders.links" />
        </div>
    </app-layout>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3';
import AppLayout from '@/Layouts/AppLayout.vue';
import PageHeader from '@/Layouts/partials/PageHeader.vue';
import CustomerNavigation from '@/Shared/CustomerNavigation';
import Pagination from '@/Jetstream/Pagination';
import JetNavLink from '@/Jetstream/NavLink';
import JetTertiaryButton from '@/Jetstream/TertiaryButton';
import { DateTime } from "luxon";

export default {
    components: {
        AppLayout,
        PageHeader,
        CustomerNavigation,
        JetNavLink,
        JetTertiaryButton,
        Link,
        Pagination,
    },

    props: ['customer', 'orders'],

    methods: {
        subtotal (order) {
            return order.order_items.reduce(function(accumulator, currentValue){
                return accumulator + (currentValue.quantity * currentValue.price);
            }, 0);
        },

        tax (order) {
            if (order.customer && order.customer.tax_exempt) return 0;

            let taxRatio = 0.13;
            let tax = order.order_items.reduce(function(accumulator, currentValue){
                return accumulator + (currentValue.tax === true ?  (currentValue.quantity * currentValue.price * taxRatio) : 0);
            }, 0);

            return tax + (this.delivery_fee(order) * taxRatio);
        },

        total (order) {
            return this.subtotal(order) + this.tax(order) + this.delivery_fee(order);
        },

        delivery_fee(order){
            return order.delivery_fee ? parseFloat(order.delivery_fee) : 0;
        },

        formatDate (date) {
            return DateTime.fromISO(date).toFormat('MMM d, yyyy');
        },

        orderUrl (order) {
            return route('orders.show', {
                order: order.id,
                return: route('customers.history', this.customer.id),
            })
        },
    }
}

</script>

<style scoped>

</style>
